import React from "react";

import casaAluguel from "../assets/images/casaAluguel.png";
import casaRemota from "../assets/images/casaRemota.png";
import solVerde from "../assets/images/solVerde.png";
import solVermelho from "../assets/images/solVermelho.png";

export function SolCasaGestaoCreditoSolar(props) {
    const fatura = props.fatura;

    if (!fatura) return null;

    const importacaoSolarPendente = parseFloat(fatura.quantidade_geracao || 0) <= 0;
    const elementoSol = (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                filter: "brightness(1.5)",
            }}
            title={importacaoSolarPendente ? "Importação Solar Pendente" : "Geração Solar Importada"}
        >
            {importacaoSolarPendente ? (
                <img alt="" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVermelho} />
            ) : (
                <img alt="" height={24} style={{ marginBottom: 6, marginRight: 3 }} src={solVerde} />
            )}
        </div>
    );

    const tipoUnidade =
        fatura.unidade_geradora && !fatura.unidade_geradora_e_remota ? (
            <div className="p-2">
                <h6>GERADORA</h6>{" "}
            </div>
        ) : null;
    const sequenciaGeradora = (
        <div>
            <span>FV{fatura.sequencia_uc_geradora}</span>{" "}
        </div>
    );

    let solCasa = null;

    if (fatura.unidade_geradora_e_remota && fatura.possui_contrato_aluguel) {
        solCasa = (
            <div title={`Geradora que aluga energia de outra usina`}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {elementoSol}
                    <img alt="" height={24} style={{ marginBottom: 6 }} src={casaAluguel}></img>
                </div>

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}></div>
            </div>
        );
    } else if (fatura.unidade_geradora_e_remota && !fatura.possui_contrato_aluguel) {
        solCasa = (
            <div title={`Geradora que recebe energia de outra usina própria`}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {elementoSol}
                    <img alt="" height={24} style={{ marginBottom: 6 }} src={casaRemota}></img>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}></div>
            </div>
        );
    } else if (!fatura.unidade_geradora_e_remota && fatura.unidade_geradora) {
        solCasa = (
            <div title={"Unidade Consumidora Geradora"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {elementoSol}
            </div>
        );
    } else if (!fatura.unidade_geradora_e_remota && fatura.unidade_remota) {
        solCasa = (
            <div title={"Unidade Consumidora Remota"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img alt="" height={24} style={{ marginBottom: 6 }} src={casaRemota}></img>
            </div>
        );
    } else if (fatura.unidade_geradora_e_remota && fatura.possui_contrato_aluguel) {
        solCasa = (
            <div title={"Unidade Consumidora Remota que aluga energia"} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img alt="" height={24} style={{ marginBottom: 6 }} src={casaAluguel}></img>
            </div>
        );
    }

    return (
        <>
            {tipoUnidade}
            {sequenciaGeradora}
            {solCasa}
        </>
    );
}
